module.exports = __webpack_public_path__ + "static/media/target.e1fa2a65.svg";